import React from "react";
import { useAppContext } from "../context/AppContext";
import { useTranslation } from "react-i18next";

export function Localization({ styles }) {
  const { changeLanguage } = useAppContext();

  const { i18n } = useTranslation();

  return (
    <div onClick={() => changeLanguage(i18n.language === 'en' ? 'lv' : 'en')}
         className="stand-localization"
         style={ styles }>
      { i18n.language === 'en' ? 'LV' : 'EN' }
    </div>
  )
}
